import React from "react"
import {
    SEARCH_DATA_GA,
    SEARCH_ICON_DATA_GA,
    SEARCH_DELETE_CURRENT_SEARCH_DATA_GA,
    SEARCH_KEY_PRESS_ENTER_DATA_GA,
    SEARCH_BOX_NAME,
} from "../../../../config/constants"
import {Container, HiddenLabel, SearchBoxContainer} from "../../component"
import urls from "../../../../config/urls"
import {handlePropagation} from "../../../../utils/handlePropagation"
import {InputContainer, Divider, SubmitButton, ClearButton, DefaultForm} from "./components"
import {useSearchBox} from "../../hooks"

type SubmitHandler = (searchTerm: string) => void

export type SearchBoxProps = {
    handleSubmit: SubmitHandler
    typing: (chars: string, siteUrl: string) => void
    autocompleteTyping: ({chars, territory, cookie}: {chars: string; territory: string; cookie?: string}) => void
    backgroundImage: string
    placeholder: string
    typedCharacters: any
    openDrawer: () => void
    labelId: string
    text: any
    realm: string
    autoFocus: boolean
    setAutoCompleteIsLoading: () => void
    siteUrl: string
    autocompleteTerritory: string
    cookie?: string
}

const {clearButton: clearButtonUrl} = urls.searchBox

export const StandardSearchBox = ({
    placeholder,
    typing,
    autocompleteTyping,
    backgroundImage,
    handleSubmit,
    openDrawer,
    typedCharacters,
    labelId,
    text: {
        label,
        clearButton: {alt},
    },
    autoFocus,
    setAutoCompleteIsLoading,
    siteUrl,
    autocompleteTerritory,
    cookie,
}: SearchBoxProps) => {
    const {
        handleFocus,
        handleClear,
        handleChange,
        handleSubmit: handleFormSubmit,
        setTextInputRef,
    } = useSearchBox({
        autoFocus,
        searchTerm: typedCharacters,
        onAutocompleteLoading: setAutoCompleteIsLoading,
        onAutocompleteTyping: autocompleteTyping,
        onSubmit: handleSubmit,
        onTyping: typing,
        onDrawerOpening: openDrawer,
        siteUrl,
        autocompleteTerritory,
        cookie,
    })

    return (
        <SearchBoxContainer>
            <Container onClick={handlePropagation}>
                <DefaultForm action={`${siteUrl}/search`} onSubmit={handleFormSubmit} id="header-search-form">
                    <HiddenLabel htmlFor={labelId}>{placeholder}</HiddenLabel>
                    <InputContainer
                        required
                        autoComplete="off"
                        inputRef={setTextInputRef}
                        inputProps={{
                            label,
                            autoFocus,
                            "data-testid": `header-search-bar-text-input`,
                            "data-ga-v1": SEARCH_DATA_GA,
                            "data-ga-enter-event": SEARCH_KEY_PRESS_ENTER_DATA_GA,
                        }}
                        type="text"
                        onChange={handleChange}
                        placeholder={placeholder}
                        onFocus={handleFocus}
                        value={typedCharacters}
                        name={SEARCH_BOX_NAME}
                        id={labelId}
                        autoFocus={autoFocus}
                    />

                    {typedCharacters && (
                        <ClearButton
                            href="#"
                            data-testid="header-search-bar-clear-text-button"
                            onClick={handleClear}
                            data-ga-v1={SEARCH_DATA_GA}
                            data-ga-v3={SEARCH_DELETE_CURRENT_SEARCH_DATA_GA}
                            tabIndex={0}
                        >
                            <img src={clearButtonUrl.path} alt={alt} />
                        </ClearButton>
                    )}
                    <Divider sx={{display: {xs: "none", md: "block"}}} orientation="vertical" />
                    <SubmitButton
                        type="submit"
                        value=""
                        data-testid="header-search-bar-button"
                        data-ga-v1={SEARCH_DATA_GA}
                        data-ga-v3={SEARCH_ICON_DATA_GA}
                        tabIndex={0}
                    >
                        <img src={backgroundImage} alt="Search Icon" />
                    </SubmitButton>
                </DefaultForm>
            </Container>
        </SearchBoxContainer>
    )
}

export default StandardSearchBox
